import { render } from "./StatsRow.vue?vue&type=template&id=5b58c1f5"
import script from "./StatsRow.vue?vue&type=script&lang=js"
export * from "./StatsRow.vue?vue&type=script&lang=js"

import "./StatsRow.vue?vue&type=style&index=0&id=5b58c1f5&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__